{
	"titleFirstPart": "Velkommen til",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Totalt lagret karbon"
}
